module.exports = __webpack_public_path__ + "static/media/blurred.760e773d.jpg";